import { ApiWidgetDimension } from "@/types/reporting/reporting.types.ts";
import { Select, SelectItem, Stack, Text } from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export type SplitByValue = ApiWidgetDimension | null;

export interface SplitBySelectorProps {
  value: SplitByValue;
  onChange: (dimension: SplitByValue) => void;
}

export function SplitBySelector({ value, onChange }: SplitBySelectorProps) {
  const { t } = useTranslation();

  const options: SelectItem[] = useMemo(
    () => [
      {
        id: "none",
        title: t("common:periods"),
      },
      {
        id: ApiWidgetDimension.department,
        title: t("core:departments"),
      },
      {
        id: ApiWidgetDimension.job_profile,
        title: t("core:job_profiles"),
      },
      {
        id: ApiWidgetDimension.job_role,
        title: t("core:job_roles"),
      },
      {
        id: ApiWidgetDimension.location,
        title: t("common:locations"),
      },
      {
        id: ApiWidgetDimension.division,
        title: t("core:divisions"),
      },
    ],
    [t]
  );

  return (
    <Stack direction={"horizontal"} gap={"xs"} items={"center"}>
      <Text className={"text-secondary"}>{t("reporting:split_by")}</Text>
      <Select
        variant={"button"}
        options={options}
        value={value ?? "none"}
        onChange={(val) => {
          onChange(val === "none" ? null : (val as ApiWidgetDimension));
        }}
        emptyTitle={t("common:select")}
      />
    </Stack>
  );
}
